import { FC } from "react";
import InventoryWebLayout from "./WebLayout";

const Inventory: FC = () => {
  return (
    <div>
      <InventoryWebLayout />
    </div>
  );
};

export default Inventory;
